import { createSortOption } from "@nosto/preact"
export const sizes = [12, 15, 24, 48, 72, 95, 96]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("name", "Alphabetically, A-Z", { field: "name", order: "asc" }),
    createSortOption("-name", "Alphabetically, Z-A", { field: "name", order: "desc" }),
    createSortOption("price", "Price, low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price, high to low", { field: "price", order: "desc" }),
    createSortOption("oldest", "Date, old to new", { field: "datePublished", order: "desc" }),
    createSortOption("newest", "Date, new to old", { field: "datePublished", order: "asc" }),
    // createSortOption("rating", "Top Rated: Lowest - Highest", { field: "ratingValue", order: "asc" }),
    // createSortOption("-rating", "Top Rated: Highest - Lowest", { field: "ratingValue", order: "desc" }),
]

export const IS_EDITORIAL = document.getElementById('nosto-collection-product-grid-container')?.getAttribute('data-layout') === 'editorial';

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: (IS_EDITORIAL) ? sizes[5] : sizes[6],
    autocompleteProductsSize: 3,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

export const popularSearches = [
    { text: "bucket", url: "" },
    { text: "504", url: ""},
    { text: "beret", url: "" },
    { text: "USA Made", url: "/collections/us-collection" }
]

export const sizesOrder = [
    "KS",
    "KM",
    "KL",
    "XS",
    "XS/S",
    "S",
    "S/M",
    "M",
    "M/L",
    "L",
    "L/XL",
    "XL",
    "XL/XXL",
    "XXL",
    "1SFM",
    "MISC",
]

export const editorialView = [
    {
        gridIndex: [5, 15],
        position: 'row-start'
    },
    {
        gridIndex: [2, 14],
        position: 'row-end'
    },
]

export const colorFilterHexes = {
    beige: "#DCC498",
    black: "#000000",
    blue: "#203A91",
    brown: "#57392E",
    green: "#13633E",
    grey: "#575757",
    ivory: "#D3D1BC",
    natural: "#B4A385",
    orange: "#C35516",
    pink: "#DA78B1",
    purple: "#41386D",
    red: "#A50318",
    tan: "#B09373",
    white: "#E9E9E9",
    yellow: "#DBC56F",
}

export const HISTORY_DROPDOWN_REC_ID = "searchdropdown-nosto-1";
export const NORESULTS_REC_ID = "noresults-nosto-1";
export const SERP_REC_ID = "searchpage-nosto-1";